// @vue/component
export default {
  name: 'CallbackFilters',

  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedProject: '',
      isSelecDisabled: false,
    };
  },
  watch: {
    projectList(newValue) {
      if (newValue.length === 1) {
        this.setDefaultSelect();
      }
    },
  },
  methods: {
    changeProject() {
      this.$emit('changeProject', this.selectedProject);
    },
    setDefaultSelect() {
      this.isSelecDisabled = true;
      this.selectedProject = this.projectList[0].uuid;
    },
  },

};
